/**
 * React Query hook for checkout operations.
 */

import { useMutation } from '@tanstack/react-query';
import { billingApi } from '@/api/client';

export function useCheckout() {
  return useMutation({
    mutationFn: async ({
      plan,
      successUrl,
      cancelUrl,
    }: {
      plan: string;
      successUrl: string;
      cancelUrl: string;
    }) => {
      const response = await billingApi.createCheckout(plan, successUrl, cancelUrl);
      return response.url;
    },
  });
}

